import { dispatchSignInInfoEvent } from "./dispatchSignInInfoEvent";
import { getToken } from "./getToken";

export async function getSignInResponse(tag?: string) {
  const token = await getToken(tag);

  if (token.tag === "data") {
    return dispatchSignInInfoEvent({
      tag: "not-normalized",
      info: token.data,
    });
  } else {
    return;
  }
}
